





































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import CardInputSKSehat from "@/components/pemeriksaan/resumeSuketV2/CardInputSKSehatJasmani.vue";
import moment from "moment";
import { SuketSehatJasmaniInterface } from "@/types/suket_sehat_jasmani";
import StoreSuketSehatJasmani from "@/store/modules/SuketSehatJasmani";
import SuketSehatJasmani from "@/services/SuketSehatJasmani";
import BaseCardSuketMultiple from "./BaseCardSuketMultiple.vue";
import { appModule } from "@/store/modules/app";
// import ErrorAlert from "@/utility/ErrorAlert";

@Component({
  components: {
    CardModalTtd,
    CardInputSKSehat,
    BaseCardSuketMultiple
  },
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class CardSKSehatJasmani extends Vue {
  @Prop() readonly register!: string;
  pageIsReadOnly!: () => boolean;

  expandInput = false;
  pageTab = "tab-soap";
  modalTtd = false;
  dataSuketActive: SuketSehatJasmaniInterface = null;

  get dataSuket(): Array<SuketSehatJasmaniInterface> {
    return StoreSuketSehatJasmani.suket;
  }

  get loadContent() {
    return StoreSuketSehatJasmani.loading;
  }

  get isReadOnly() {
    return this.pageIsReadOnly();
  }

  tglSurat(date) {
    return moment(date).format("DD-MM-YYYY");
  }

  setActive(data: SuketSehatJasmaniInterface) {
    this.dataSuketActive = data;
  }

  edit(data: SuketSehatJasmaniInterface) {
    this.dataSuketActive = data;
    this.showInput();
  }

  add() {
    this.dataSuketActive = null;
    this.showInput();
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SuketSehatJasmani.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
    this.dataSuketActive = null;
  }

  getHumanDate(date) {
    return date ? moment(date).format("DD MMMM YYYY") : "";
  }

  showSignatureModal(timeout = 0) {
    setTimeout(() => {
      this.modalTtd = true;
      if (!this.dataSuketActive) {
        this.dataSuketActive = this.dataSuket[this.dataSuket.length - 1];
      }
    }, timeout);
  }

  passTtd(value) {
    appModule.setLoading(true);

    // console.log(value);
    SuketSehatJasmani.sign(this.dataSuketActive.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan SKDP");
          appModule.addMsgTtd("");
          StoreSuketSehatJasmani.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }

  remove(item) {
    SuketSehatJasmani.destroy(item.id).then(dt => {
      if (dt.status == 1) {
        appModule.NoticeDelay("Berhasil Hapus Surat Keterangan Dokter");
        StoreSuketSehatJasmani.getSuketByRegister(this.register);
      } else {
        appModule.sendErrorAlert(dt.message);
      }
    });
  }
}
